import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}salesleads/resendconfirmation`;

interface ResendSalesLeadEmailConfirmationCommandArgs {
  email: string;
}

const resendSalesLeadEmailConfirmationCommand = async ({
  email,
}: ResendSalesLeadEmailConfirmationCommandArgs): Promise<
  BaseBackResponse | BackResponseFailure
> => {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        email,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default resendSalesLeadEmailConfirmationCommand;
